import React from 'react'
import PropTypes from 'prop-types'
import { ModalWrapper, Modal } from '@gluedigital/modal'
import Metas from './Metas'
import Header from 'src/components/Header'
import Footer from 'src/components/Footer'

import './Layout.sass'

export const Layout = (props) => {
  let content = props.children

  const routes = props.router.routes
  const lastRoute = routes[routes.length - 1]
  let pageName = lastRoute.title

  return (
    <ModalWrapper>
      <main id="layout">
        <Metas />
        <Header pageName={pageName} />
        {content}
        <Footer pageName={pageName} />
        <Modal />
      </main>
    </ModalWrapper>
  )
}

Layout.propTypes = {
  router: PropTypes.object.isRequired,
  children: PropTypes.element
}

export default Layout
